// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowSuggestion-cls1_JIs","cls2":"BulkFollowSuggestion-cls2_h5l BulkFollowSuggestion-cls1_JIs"};